export default __webpack_public_path__ + "static/media/leedarson-a215.6066f547.svg";